import { FC } from 'react'
import { Outlet } from 'react-router-dom'

// ROUTES
import { KycExplainerRoute } from './explainer'
import { KycPhoneRoute } from './phone'
import { KycVerifyRoute } from './verify'

// TYPES
import type { RouteObject } from 'react-router-dom'


const Component: FC = () => <Outlet />

const KycRoute: RouteObject = {
    path: 'kyc',
    Component,
    children: [
        KycExplainerRoute,
        KycPhoneRoute,
        KycVerifyRoute,
    ],
}

export default KycRoute
